<template>
	<Modal @close="$emit('close')" size="small">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<h3>Edit Location</h3>
				</div>
			</div>
			<Form :location="location" @close="$emit('close')"/>
		</div>
	</Modal>
</template>

<script>
import Modal from './../Modal.vue'
import Form from './Form.vue'

export default {
	components: {
		Modal,
		Form
	},
	props: [
		'location'
	]
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Locations/Edit.vue